export default "__VITE_ASSET__Bg0quWH3__"